/**
 * ADA accessibility fix for the "Notify! Back in Stock | PreOrder" app.
 *
 * Moved verbatim out of an inline <script> in
 * snippets/notify-wishlist-a11y.liquid. The snippet renders on every page from
 * layout/theme.liquid, so as inline markup this ~2 KB shipped uncached with
 * every HTML response; as a deferred asset it is fetched once and cached.
 *
 * The app injects its wishlist login modal and wishlist drawer at the end of
 * <body>, outside any landmark region. Accessibility audits (axe "region"
 * best-practice rule) flag this because all visible content should live inside
 * a landmark. We cannot edit the app's markup, so this assigns the
 * semantically-correct role ("dialog" + accessible label) to the app's
 * top-level containers once they appear in the DOM. Dialog content is exempt
 * from the landmark requirement, which clears the failing elements.
 *
 * A MutationObserver keeps the roles applied because the app injects and
 * re-renders these nodes dynamically.
 */
(function () {
  // Container selector -> accessible label fallback.
  // The app's own visible heading is used as the label when present.
  var TARGETS = [
    { selector: '.nm-wishlist-login-modal', label: 'Wishlist login' },
    { selector: '.nm-wishlist-drawer', label: 'Wishlist' }
  ];

  function labelFor(el, fallback) {
    // Prefer the dialog's own visible title/heading text if available.
    var titleEl = el.querySelector(
      '.nm-wishlist-drawer-title, .nm-wishlist-login-modal-header, [class*="-title"], [class*="-header"]'
    );
    var text = titleEl && titleEl.textContent ? titleEl.textContent.trim() : '';
    return text || fallback;
  }

  function apply(root) {
    var scope = root && root.querySelectorAll ? root : document;
    TARGETS.forEach(function (t) {
      var nodes = scope.querySelectorAll(t.selector);
      nodes.forEach(function (el) {
        if (el.getAttribute('role') === 'dialog') return;
        el.setAttribute('role', 'dialog');
        if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
          el.setAttribute('aria-label', labelFor(el, t.label));
        }
      });
      // Also handle the case where the matched node IS the added root.
      if (root && root.matches && root.matches(t.selector) && root.getAttribute('role') !== 'dialog') {
        root.setAttribute('role', 'dialog');
        if (!root.getAttribute('aria-label') && !root.getAttribute('aria-labelledby')) {
          root.setAttribute('aria-label', labelFor(root, t.label));
        }
      }
    });
  }

  function init() {
    apply(document);
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) apply(added[j]);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
